import { centsFor } from './swarasthanas.js';
/** 12-symbol swara → target cents for this raga (swarasthana table + intonation_overrides). */
export function ragaTargetCents(record) {
    const out = {};
    for (const [sym, sw] of Object.entries(record.swara_variants))
        out[sym] = centsFor(sw, record.intonation_overrides);
    return out;
}
//# sourceMappingURL=target.js.map